export default __webpack_public_path__ + "static/media/click-pariuri.92c4b415.svg";